const STORAGE_KEY = "unit_system";
/**
 * The doctor's own reading preference, stored the way the theme is.
 *
 * It is deliberately the doctor's and not the patient's: a doctor reads thirty
 * patients side by side, and mixing kilograms and pounds down one list makes
 * the column unsortable and the comparison misleading. What the patient chose
 * shows up as a hint on their card, never as the scale of the list.
 *
 * Like the theme, this only changes what is rendered. Every value on the wire
 * stays metric.
 */
export function getStoredDoctorUnitSystem() {
    if (typeof document === "undefined")
        return null;
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored === "metric" || stored === "imperial")
            return stored;
    }
    catch (_a) {
        // Private mode and blocked site data both land here; fall through to the
        // backend value.
    }
    return null;
}
export function persistDoctorUnitSystem(system) {
    try {
        localStorage.setItem(STORAGE_KEY, system);
    }
    catch (_a) {
        // ignore
    }
}
/**
 * Picks the system to render in.
 *
 * The device choice wins so a toggle takes effect immediately; the backend
 * value carries it to another machine. Neither present means metric, which is
 * what the data already is.
 */
export function resolveDoctorUnitSystem(storedSystem, backendSystem) {
    if (storedSystem)
        return storedSystem;
    if (backendSystem === "metric" || backendSystem === "imperial") {
        return backendSystem;
    }
    return "metric";
}
